var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getIsLoading)?_c('div',{staticClass:"loader-content"},[_c('div',{staticClass:"loader"},[_vm._v("Loading...")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }